<template >
  <v-container class="input-text-size">
    <template v-if="showDialogContent()">
    <v-row dense class="input-text-size">
      <v-col cols="3">
        <ClarionDateControl class="input-text-size" :isRequired="false" :isToggle="false"
          label="Apportionment from Date" v-model="editedItem.fromDate" :isDisabled="isReadOnly"
          :isReadOnly="true" />
      </v-col>
      <v-col cols="3">
        <ClarionDateControl
          class="input-text-size"
          :isRequired="false"
          :isToggle="false"
          label="Apportionment To Date"
          v-model="editedItem.toDate"
          :isReadOnly="true"
          :isDisabled="isReadOnly"
        />
      </v-col>
            <v-col cols="3">
        <ClarionDateControl
          class="input-text-size"
          :isRequired="false"
          :isToggle="false"
          label="Business Date"
          v-model="editedItem.businessDate"
          :isDisabled="isReadOnly"
        />
      </v-col>
       <v-col cols="3">
          <v-text-field
          dense
          class="mt-5"
          v-model.number="editedItem.taxYear"
          label="Tax Year"
          hide-details
          :readonly="isReadOnly"
        />
      </v-col>

      <!-- <v-col cols="4" class="mt-4">
        <ClarionDateControl class="input-text-size" :isRequired="false" :isToggle="false"
          label="Apportionment Proxy from Date"
          v-model="editedItem.proxyFromDate" :isDisabled="isReadOnly" />
      </v-col> -->
      <v-col cols="8" class="mt-n3">
        <v-select
          class="input-text-size"
          :items="taxDistrictList"
          @keydown="(e) => taxesShortcutHandler(e, 'taxDistrict')"
          item-text="taxDistrictCodeAndName"
          item-value="districtCode"
          label="Tax District"
          dense
          :readonly="isReadOnly"
          :rules="taxDistrictRules"
          v-model="editedItem.schoolDistrict"
        />
      </v-col>
      <v-col cols="4" class="mt-n8">
        <v-select class="input-text-size"
        label="Record type"
        :readonly="isReadOnly"
        v-model="editedItem.recordType"
        :items= "isVisibleProp"
        item-text="description"
        item-value="name"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          dense
          v-model="editedItem.taxAmt"
          :readonly="isReadOnly"
          hide-details
          label="Tax Amount"
          class="input-text-size"
          id="apport-taxes-tax-amt"
          @blur="roundAmount('taxAmt')"
          @focus="handleTaxAmtFocus($event)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          dense
          :readonly="isReadOnly"
          v-model="editedItem.penaltyAmount"
          hide-details
          label="Penalty Amount"
          class="input-text-size"
          @blur="roundAmount('penaltyAmount')"
          @focus="handleTaxAmtFocus($event)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          dense
          v-model="editedItem.totalFees"
          label="Fee Total"
          hide-details
          :readonly="isReadOnly"
          @blur="roundAmount('totalFees')"
          class="input-text-size"
          @focus="handleTaxAmtFocus($event)"
        @keydown="(e) => taxesShortcutHandler(e, 'totalFees')" />
      </v-col>
      <v-col cols="6">
        <v-text-field
          dense
          v-model="editedItem.totalAmount"
          :value="editedItem.totalAmount"
          hide-details
          label="Total Amount"
          readonly
          @blur="roundAmount('totalAmount')"
          @focus="handleTaxAmtFocus($event)"
          class="input-text-size mt-3"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          dense
          label="Gross Assessed"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.grossAssessed"
          hide-details
          :readonly="isReadOnly"
          class="input-text-size mt-3"
        />
      </v-col>

      <v-col cols="5" class="mt-2">
        <v-checkbox class="mt-4" dense label="Exempt Manufacturing"
         outlined hide-details v-model="editedItem.isExempt" :readonly="isReadOnly" />
      </v-col>
      <v-col cols="6" v-if="editedItem.isManualRecord">
        <v-checkbox
          label="Skip TIF"
          class="input-text-size mt-4"
          dense
          :readonly="isReadOnly"
          v-model="editedItem.skipTIF"
        >
        </v-checkbox>
      </v-col>
            <v-col cols="6">
        <v-textarea
          dense
          label="description"
          outlined
          hide-details
          class="input-text-size"
          v-textAreaUppercase=globalSettingItem.conEverythingToCaps v-model="editedItem.description"
          :readonly="isReadOnly"
          id="apport-taxes-description" />
      </v-col>
    </v-row>
    </template>
    <template v-else>
      <v-row>
        <v-col cols="12" class="text-center">
          <span>Please select From Date and To Date in Criteria to add new Record.</span>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import '../../../assets/style.css';
// import { amountFields } from './taxes.Utils';
import { amountFormat, amountToNumber } from '../../../util/shared/vue-global';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  mixins: [GlobalToCaps],
  data() {
    return {
    };
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  created() {

  },
  components: {
    ClarionDateControl,
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'items', 'isVisible', 'criteria']),
    ...mapState({
      apportionmnetRecordTypes: (state) => state.enums.ApportionmentRecordTypeEnum || [],
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        const item = this.item(this.baseCrudKey);
        // amountFields.forEach((f) => {
        //   item[f] = amountFormat(amountToNumber(item[f]));
        // });
        return item;
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    isVisibleProp() {
      const isVisible = this.isVisible(this.baseCrudKey);
      if (isVisible) {
        this.updateEditItem();
      }
      return this.apportionmnetRecordTypes;
    },
    isReadOnly() {
      return this.editedItem.isLocked;
    },
    // Apportionment groups and sums by the tax district (schoolDistrict), so a record saved
    // without one drops out of those groupings and prints as a blank line on the reports.
    // The v-form this dialog sits in blocks the save while this rule fails.
    taxDistrictRules() {
      return [
        (v) => (!!v && `${v}`.trim() !== '') || 'Tax District is required.',
      ];
    },
    taxDistrictList() {
      const taxDistrictBaseCrudKey = 'sharedTaxDistrict';
      const items = this.items(taxDistrictBaseCrudKey);
      const updatedItem = items.map((i) => ({
        ...i,
        taxDistrictCodeAndName: `${i.districtCode} ${i.districtName || ''}`,
      }));
      return [...updatedItem];
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
    ...mapActions('shared/taxDistrict', [
      'loadTaxDistrict',
    ]),
    showDialogContent() {
      // If editing an existing item, always show content (don't check dates)
      if (this.editedItem._id) {
        return true;
      }
      // If creating a new record, check for from and to date values
      return this.criteriaState.fromDateValue && this.criteriaState.toDateValue;
    },
    updateEditItem() {
      // const flag = this.editedItem.isNormalRecord === undefined
      //   ? true
      //   : this.editedItem.isNormalRecord;
      let flag;
      if (this.editedItem.isNormalRecord === undefined) {
        if (this.criteriaState.typeOfRecord === true) {
          flag = false;
        } else {
          flag = true;
        }
      } else {
        flag = this.editedItem.isNormalRecord;
      }
      if (flag) {
        this.editedItem.recordType = 'NORMALRECORD';
      } else {
        this.editedItem.recordType = 'TRIALRECORD';
      }
    },
    handleTaxAmtFocus(event) {
      if (this.editedItem.taxAmt === 0) {
        this.editedItem.taxAmt = '';
      }
      event.target.select();
    },
    roundAmount() {
      // this.editedItem[field] = amountFormat(amountToNumber(this.editedItem[field]));
      this.editedItem.taxAmt = amountFormat(amountToNumber(this.editedItem.taxAmt));
      this.editedItem.totalFees = amountFormat(amountToNumber(this.editedItem.totalFees));
      this.editedItem.penaltyAmount = amountFormat(amountToNumber(this.editedItem.penaltyAmount));
      this.editedItem.totalAmount = amountFormat(amountToNumber(this.editedItem.totalAmount));
      this.calculatedTotalAmount();
    },
    amountToNum() {
      // this.editedItem[] = amountToNumber(this.editedItem[]);
      this.editedItem.taxAmt = amountToNumber(this.editedItem.taxAmt);
      this.editedItem.totalFees = amountToNumber(this.editedItem.totalFees);
      this.editedItem.penaltyAmount = amountToNumber(this.editedItem.penaltyAmount);
      this.editedItem.totalAmount = amountToNumber(this.editedItem.totalAmount);
      this.calculatedTotalAmount();
    },
    calculatedTotalAmount() {
      const { taxAmt, totalFees, penaltyAmount } = this.editedItem;
      const totalAmt = amountFormat(amountToNumber(taxAmt)
      + amountToNumber(totalFees) + amountToNumber(penaltyAmount));
      if (!this.editedItem._id) {
        this.editedItem.totalAmount = 0;
        this.editedItem.totalAmount = totalAmt;
      }
    },
    taxesShortcutHandler(e, fromWhere) {
      if (e.key === 'Tab') {
        e.preventDefault();
        if (fromWhere === 'taxDistrict') document.getElementById('apport-taxes-tax-amt').focus();
        else if (fromWhere === 'totalFees') document.getElementById('apport-taxes-description').focus();
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  max-width: 600px;
  margin: 0 auto;
}

</style>
